import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SBProTopNav from '@structural/top-nav.vue';
import SBProPageHeader from '@structural/page-header.vue';
import SBProLayoutDefault from '@structural/layout-default.vue';
import SBProPageSection from '@structural/page-section.vue';
let SBProRegisterLogin = class SBProRegisterLogin extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = 'register';
        this.registerForm = {
            username: '',
            email: '',
            password: '',
        };
        this.username = '';
        this.email = '';
        this.password = '';
        this.loginForm = {
            username: '',
            password: '',
        };
    }
    register() {
        const { username, email, password } = this.registerForm;
        if (localStorage.getItem(username)) {
            this.$bvModal.show("modal-tongming");
            return;
        }
        const userData = {
            email,
            password
        };
        localStorage.setItem(username, JSON.stringify(userData));
        this.$bvModal.show("modal-zhucechenggong");
        this.registerForm.username = '';
        this.registerForm.email = '';
        this.registerForm.password = '';
    }
    login() {
        const { username, password } = this.loginForm;
        const storedUser = localStorage.getItem(username);
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            if (userData.password === password) {
                location.href = "/";
                // 这里可以跳转到其他页面或进行其他登录成功后的操作
            }
            else {
                this.$bvModal.show("modal-2");
            }
        }
        else {
            this.$bvModal.show('modal-1');
        }
        // this.loginForm.username = '';
        // this.loginForm.password = '';
    }
};
SBProRegisterLogin = __decorate([
    Component({
        components: {
            'sbpro-top-nav': SBProTopNav,
            'sbpro-page-header': SBProPageHeader,
            'sbpro-layout-default': SBProLayoutDefault,
            'sbpro-page-section': SBProPageSection,
        },
    })
], SBProRegisterLogin);
export default SBProRegisterLogin;
;
